// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let ModuleHeaderUi = class ModuleHeaderUi extends Vue {
};
__decorate([
    Prop({ type: Object, required: true })
], ModuleHeaderUi.prototype, "header", void 0);
ModuleHeaderUi = __decorate([
    Component({
        name: 'ModuleHeaderUi',
        template: `
    <header class="module-header">
      <h2 class="module-header__large">
        <small v-if="header.small" v-html="header.small" class="module-header__small" />
        <span v-if="header.large" v-html="header.large" />
      </h2>

      <p v-if="header.intro && header.intro.text" v-html="header.intro.text"
         class="module-header__intro" :class="{ 'fw-bold': header.intro.isBold }" />
    </header>
  `
    })
], ModuleHeaderUi);
export { ModuleHeaderUi };
